


































































































































































































































































































































import {
  Component, Vue, Prop, PropSync, Watch,
} from 'vue-property-decorator';

import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import FormInput from '@/components/FormInput.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';

import numberFormat from '@/libs/numberFormat';
import hasPermission from '@/libs/permission';

@Component({
  components: {
    LayoutContent,
    Button,
    FormInput,
  },
  methods: {
    numberFormat,
    hasPermission,
  },
})

export default class InternalBillingSummary extends Vue {
  /* eslint-disable */
  numberFormat!: typeof numberFormat;
  hasPermission!: (val: string | string[]) => boolean;

  $refs!: {
    'file-input': HTMLInputElement;
  }

  displayBillType: any = {
    normal: 'Normal',
    mdr: 'MDR',
    mixed: 'Normal & MDR',
    tiring: 'Tiring',
    tiring_amount: 'Tiring Amount',
  }

  fileData: File | null = null;
  selectedReason: number = -1;
  listReason: string[] = [
    'Tidak ada konfirmasi dari merchant sehingga traffic mengikuti dari Bayarind',
    'Merchant request agar diterbitkan saja invoicenya',
    ''
  ];

  sumTotal(type: string) {
    try {
      // let result: any = {
      //   merchant_traffic: 0,
      //   merchant_billing: 0,
      //   sprint_traffic: 0,
      //   sprint_billing: 0,
      //   amount: 0,
      //   merchant_amount: 0,
      //   difference_percentage: 0,
      //   difference_amount: 0,
      // };
      switch (type) {
        case "merchant_traffic": {
          let totalMerchantTraffic: number = 0;
          this.trafficPerDay.forEach((data: any) => {
            totalMerchantTraffic += parseFloat(data.merchant_traffic || 0);
          })
          return totalMerchantTraffic;
        }
        case "sprint_traffic": {
          let totalSprintTraffic: number = 0;
          this.trafficPerDay.forEach((data: any) => {
            totalSprintTraffic += parseFloat(data.sprint_traffic || 0);
          })
          return totalSprintTraffic;
        }
        case "amount": {
          let totalAmount: number = 0;
          this.trafficPerDay.forEach((data: any) => {
            totalAmount += parseFloat(data.amount || 0);
          })
          return totalAmount;
        }
        case "merchant_amount": {
          let totalMerchantAmount: number = 0;
          this.trafficPerDay.forEach((data: any) => {
            totalMerchantAmount += parseFloat(data.merchant_amount || 0);
          })
          return totalMerchantAmount;
        }
        case "merchant_billing": {
          let totalMerchantBilling: number = 0;
          const price: any[] = this.getPrice(true) || [];
          this.trafficPerDay.forEach((data: any) => {
            switch (this.getBillType()) {
              case 'normal':
              case 'tiring': {
                totalMerchantBilling += parseFloat(data.merchant_traffic || 0) * parseFloat(price[0] || 0);
                break;
              }
              case 'mdr': {
                totalMerchantBilling += parseFloat(data.merchant_amount || 0) * parseFloat(price[0] || 0);
                break;
              }
              case 'mixed': {
                totalMerchantBilling += (parseFloat(data.merchant_traffic || 0) * parseFloat(price[0] || 0)) + (data.merchant_amount * parseFloat(price[1]));
              }
              case "tiring_amount": {
                if (price[1] === 'normal') {
                  totalMerchantBilling += parseFloat(data.merchant_traffic || 0) * parseFloat(price[0] || 0);
                } else if (price[1] === 'mdr') {
                  totalMerchantBilling += data.merchant_amount * parseFloat(price[0] || 0);
                }
                break;
              }
            }
          })
          return totalMerchantBilling;
        }
        case "sprint_billing": {
          let totalSprintBilling: number = 0;
          const price: any[] = this.getPrice() || [];
          this.trafficPerDay.forEach((data: any) => {
            switch (this.getBillType()) {
              case 'normal':
              case 'tiring': {
                totalSprintBilling += parseFloat(data.sprint_traffic || 0) * parseFloat(price[0] || 0);
                break;
              }
              case 'mdr': {
                totalSprintBilling += parseFloat(data.amount || 0) * parseFloat(price[0] || 0);
                break;
              }
              case 'mixed': {
                totalSprintBilling += (parseFloat(data.sprint_traffic || 0) * parseFloat(price[0] || 0)) + (data.amount * parseFloat(price[1]));
              }
              case "tiring_amount": {
                if (price[1] === 'normal') {
                  totalSprintBilling += parseFloat(data.sprint_traffic || 0) * parseFloat(price[0] || 0);
                } else if (price[1] === 'mdr') {
                  totalSprintBilling += data.amount * parseFloat(price[0] || 0);
                }
                break;
              }
            }
          })
          return totalSprintBilling;
        }
        case "difference_percentage": {
          let differencePercentage: number = (this.sumTotal("sprint_traffic") - this.sumTotal("merchant_traffic")) * 100 / (this.sumTotal("sprint_traffic") || 1);
          if (differencePercentage > 100) {
            differencePercentage = 100;
          } else if (differencePercentage < -100) {
            differencePercentage = -100;
          };
          return differencePercentage;
        }
        case "difference_amount": {
          const differenceAmount: number = this.sumTotal("sprint_traffic") - this.sumTotal("merchant_traffic");
          return differenceAmount;
        }
      }
      return 0;
    } catch (error) {
      console.log(error);
      return 0;
    }
  }

  openFileInput() {
    this.$refs['file-input'].click();
  }

  async onFileDrag(event: DragEventInit) {
    if (!event.dataTransfer) return;
    const [file] = event.dataTransfer.files;
    this.fileData = file;
    // this.process();
  }

  cancelDisagreeClick() {
    try {
      this.internalDisagree = false;
      this.$emit('buttonClick', 'cancelDisagree');
    } catch (error) {
      console.log(error);
    }
  }

  async onFileInput(event: Event) {
    this.fileData = null;
    const target = event.target as HTMLInputElement;
    const { files } = target;

    if (files === null || files.length === 0) return;
    const file = files[0];
    if (file.size <= 100000) {
      this.fileData = file;
    } else {
      showToast(ToastType.FAILED, 'Confirm Failed', 'Max file size is 100KB');
    }

    // this.process();
  }

  disableSubmit() {
    try {
      console.log('type', this.getBillType());
      if (/normal|tiring/.test(this.getBillType())) {
        return false;
      } else {
        for (const data of (this.trafficPerDay || [])) {
          if (data.merchant_traffic != data.sprint_traffic) {
            if (data.merchant_amount == data.amount) {
              return true;
            }
          } else {
            if (data.merchant_amount != data.amount) {
              return true;
            }
          }
        }
        return false;
      }
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  get imagePreview() {
    try {
      if (this.fileData) {
        return URL.createObjectURL(this.fileData)
      }
      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  get missingReason() {
    try {
      if (this.selectedPeriod.merchant_traffic.status === 0) {
        if (this.selectedReason === 0 || this.selectedReason === 1) {
          return false;
        } else if (this.selectedReason === 2) {
          return this.listReason[2] ? false : true;
        }
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return true;
    }
  }

  getBillType() {
    try {
      let multiple_billType = JSON.parse(this.selectedPeriod.multiple_billType || "[]");
      if (multiple_billType.length > 1) {
        return 'mixed';
      } else if (multiple_billType.length > 0) {
        return multiple_billType[0].type;
      } else {
        return this.selectedPeriod.billType;
      };
    } catch (error) {
      console.log(error);
      return '';
    }
  }

  getPrice(isMerchant = false) {
    try {
      let multiple_billType = JSON.parse(this.selectedPeriod.multiple_billType || "[]");
      if (multiple_billType.length > 0) {
        switch (this.getBillType()) {
          case 'normal':
          case 'mdr':
          case 'mixed': {
            return multiple_billType.map((val: any) => val.price);
          }
          case 'tiring': {
            console.log('price tiring');
            let tiringPrice = multiple_billType[0].price || [];
            let totalTraffic = 0;
            if (isMerchant) {
              totalTraffic = this.sumTotal('merchant_traffic') || 0
            } else {
              totalTraffic = this.sumTotal('sprint_traffic') || 0
            }
            if (tiringPrice.length > 0) {
              for (const data of tiringPrice) {
                if (parseInt(data.traffic_min) <= totalTraffic && totalTraffic <= parseInt(data.traffic)) {
                  return [data.price]
                }
              };
            }
          }
          case 'tiring_amount': {
            let tiringPrice = multiple_billType[0].price || [];
            let totalAmount = this.sumTotal('merchant_amount') || 0;
            if (isMerchant) {
              totalAmount = this.sumTotal('merchant_amount') || 0
            } else {
              totalAmount = this.sumTotal('amount') || 0
            }
            if (tiringPrice.length > 0) {
              for (const data of tiringPrice) {
                if (parseInt(data.traffic_min) <= totalAmount && totalAmount <= parseInt(data.traffic)) {
                  return [data.price, data.type]
                }
              };
            }
          }
        }
      } else {
        return [this.selectedPeriod.price_per_transaction];
      }
      return []
    } catch (error) {
      console.log(error);
      return []
    }
  }

  displayPrice(isMerchant = false) {
    switch (this.getBillType()) {
      case 'normal': {
        return numberFormat(this.getPrice()[0], true);
      }
      case 'mdr': {
        return `${numberFormat((this.getPrice()[0] || 0) * 100)}%`
      }
      case 'mixed': {
        const listPrice = this.getPrice() || []
        return `${numberFormat(listPrice[0], true)} & ${numberFormat((listPrice[1] || 0) * 100)}%`;
      }
      case 'tiring': {
        return numberFormat(this.getPrice(isMerchant)[0], true)
      }
      case 'tiring_amount': {
        const listPrice = this.getPrice() || []
        return listPrice[1] === 'normal' ?
          numberFormat(this.getPrice(isMerchant)[0], true) :
          listPrice[1] === 'mdr' ? `${numberFormat((this.getPrice()[0] || 0) * 100)}%` : "-";
      }
    }
  }

  @PropSync('internalDisagreeProp', { type: Boolean }) internalDisagree!: boolean;
  @Prop() readonly selectedPeriod!: any;
  @Prop() readonly trafficPerDay!: any;

  @Watch('selectedPeriod')
  changePeriod() {
    this.fileData = null;
    this.selectedReason = -1;
  }
}
